/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditConfirmationResponse
 */
export interface EditConfirmationResponse {
    /**
     * 
     * @type {string}
     * @memberof EditConfirmationResponse
     */
    bookingId: string;
    /**
     * 
     * @type {string}
     * @memberof EditConfirmationResponse
     */
    confirmationNumber: string;
}

/**
 * Check if a given object implements the EditConfirmationResponse interface.
 */
export function instanceOfEditConfirmationResponse(value: object): value is EditConfirmationResponse {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('confirmationNumber' in value) || value['confirmationNumber'] === undefined) return false;
    return true;
}

export function EditConfirmationResponseFromJSON(json: any): EditConfirmationResponse {
    return EditConfirmationResponseFromJSONTyped(json, false);
}

export function EditConfirmationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditConfirmationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'confirmationNumber': json['confirmation_number'],
    };
}

export function EditConfirmationResponseToJSON(json: any): EditConfirmationResponse {
    return EditConfirmationResponseToJSONTyped(json, false);
}

export function EditConfirmationResponseToJSONTyped(value?: EditConfirmationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'confirmation_number': value['confirmationNumber'],
    };
}

